import { fetchWrapper } from '@/_helpers';
import React, { useEffect, useState } from 'react';
import { BsStarFill, BsStar } from 'react-icons/bs';
import { VscLoading } from 'react-icons/vsc';
import { css } from 'twin.macro';

const MessageStar = ({ m, rId, subChannelId }) => {
    const messageId = m?.id || m?._id;
    const initialStarred = Boolean(m?.isStarred);

    const [starredLocally, setStarredLocally] = useState(initialStarred);
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        setStarredLocally(initialStarred);
    }, [initialStarred, messageId]);

    const handleStar = async () => {
        if (isUpdating) {
            return;
        }

        const currentlyStarred = starredLocally;
        setIsUpdating(true);

        try {
            let endpoint;
            if (subChannelId) {
                endpoint = `subchannels/${subChannelId}/${messageId}/stars${currentlyStarred ? '?remove=true' : ''}`;
            } else if (rId) {
                endpoint = `chatrooms/${rId}/${messageId}/stars${currentlyStarred ? '?remove=true' : ''}`;
            } else {
                throw new Error('Missing chatroom or subchannel id');
            }
            await fetchWrapper.put(endpoint, {});
            setStarredLocally(!currentlyStarred);
        } catch (err) {
            console.error(err?.message || 'Failed to update star. Please try again.');
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <div
            onClick={handleStar}
            css={css`
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 4px;
                opacity: ${isUpdating ? 0.25 : 1};
                pointer-events: ${isUpdating ? 'none' : 'auto'};
                svg {
                    color: ${starredLocally ? '#ffc107' : '#50aeb0'};
                }
                :hover svg {
                    color: #ffc107;
                }
            `}
            className="dropper star-icon mx-2"
            aria-busy={isUpdating}
            aria-disabled={isUpdating}
        >
            {isUpdating ? (
                <VscLoading size={24} className="spin" />
            ) : starredLocally ? (
                <BsStarFill size={24} />
            ) : (
                <BsStar size={24} />
            )}
        </div>
    );
};

export default MessageStar;
